import React from 'react';
import { DefaultLanding } from './Landing';

// This advertising URL deliberately reuses the homepage component. It keeps
// the visual page and registration mechanics identical while preserving a
// dedicated path and first-party landing event for VK traffic.
const VkRegisterLanding = () => <DefaultLanding trackingKey="vk-register" />;

export default VkRegisterLanding;
